import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
// components
import { StyledWrapper, StyledList } from "./optionswrapper.styles";
import { StyledOption } from "./option.styles";
export function OptionsWrapper({ items, onChange, initialSelectedOption, outlined, className, }) {
    const [selectedOptionValue, setSelectedOptionValue] = useState(initialSelectedOption);
    const wrapperRef = useRef(null);
    function handleChange(item) {
        setSelectedOptionValue(item.value);
        if (typeof onChange === "function") {
            onChange(item);
        }
    }
    useEffect(() => {
        const { activeElement } = document;
        const selectedOptionLi = wrapperRef.current.querySelector('[data-is-selected="true"]');
        if (activeElement.firstChild.parentElement.dataset.focusVisible === "true" &&
            selectedOptionLi) {
            selectedOptionLi.focus();
        }
    }, []);
    return (_jsx(StyledWrapper, Object.assign({ className: className, ref: wrapperRef, outlined: outlined }, { children: _jsx(StyledList, { children: items.map((item) => {
                return (_jsx(StyledOption, Object.assign({ "data-is-selected": selectedOptionValue === item.value, onClick: () => {
                        handleChange(item);
                    }, isSelected: selectedOptionValue === item.value, tabIndex: 0 }, { children: item.text }), item.text));
            }) }) })));
}
